import React from 'react';

import { Box } from '@mui/material';

import ToolItem from './ToolItem';

import { useHandleToolClick, useTools } from './hooks';

import { useStyles } from './styles';
import { ITools } from './interfaces';

const Tools = ({ onClose }: ITools) => {
  const classes = useStyles();

  const tools = useTools();
  const handleToolClick = useHandleToolClick(onClose);

  return (
    <Box sx={classes.root}>
      {tools.map(({ icon, name, description, action }) => (
        <ToolItem
          key={name}
          icon={icon}
          name={name}
          description={description}
          onClick={() => handleToolClick(action)}
        />
      ))}
    </Box>
  );
};

export default Tools;
